import httpService from '@Utils/httpService';

const baseUrl = 'api/AnalysisJobs';

// AnalysisJobsController.TypeHead resets ItemsPerPage <= 0 to 1000; ask for the same explicitly.
export const JOBS_PAGE_SIZE = 1000;

export default {
	/**
	 * FullScan: { facilityId, imagesIds }. AvaInspect: { facilityId, jobType: 'AvaInspect', avaInspectId, snapIds? }
	 * (no snapIds = every snap of the tag); the API crops each snap's stored image outline itself.
	 */
	startAnalysisJob(data) {
		return httpService.post({
			url: `${baseUrl}/startAnalysisJob`,
			data,
		});
	},
	listJobs(facilityId) {
		return httpService.get({
			url: `${baseUrl}/TypeHead`,
			timeout: 20000,
			params: { facilityId, page: 1, itemsPerPage: JOBS_PAGE_SIZE, sortBy: 'CreateDate', sortDesc: true },
		});
	},
	getJob(id) {
		return httpService.get({ url: `${baseUrl}/${id}` });
	},
	getActivity(id, signal) {
		return httpService.get({ url: `${baseUrl}/${id}/activity`, signal, timeout: 20000 });
	},
	cancelJob(id) {
		return httpService.post({ url: `${baseUrl}/${id}/cancel`, timeout: 40000 });
	},
	/** Snaps of an AVA Inspect tag; the controller resolves the tag in the facility named by X-Facility-Id. */
	getSnaps(facilityId, avaInspectId) {
		return httpService.get({
			url: `api/tags/ava-inspect/${encodeURIComponent(avaInspectId)}/snaps`,
			headers: facilityId ? { 'X-Facility-Id': facilityId } : {},
		});
	},
};
